export default __webpack_public_path__ + "static/03_V1@2x-2bfd9ba262832aef52b7bb853fe6d652.png";